module.exports = __webpack_public_path__ + "media/ani-course-intro.175bf834.mp4";